import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { each } from 'lodash';

export default class LazyLoader extends Component {
	constructor() {
		super({
			element: null,
			elements: {
				sections: document.querySelectorAll('section'),
			},
		});
	}

	init() {
		this.createComponent();
		this.createScrollTrigger();
	}

	createScrollTrigger() {
		this.elements.sections = null;
		this.elements.sections = document.querySelectorAll('section');

		each(this.elements.sections, (section) => {
			if (!section) return;
			const videos = section.querySelectorAll('video[data-src]');
			each(videos, (video) => {
				ScrollTrigger.create({
					trigger: section,
					start: 'top bottom-=100',
					onEnter: () => {
						this.loadVideo(video);
					},
				});
				video.addEventListener('loadeddata', () => {
					video.muted = true;
					video.play().catch(() => {});
				});
			});

			const images = section.querySelectorAll('img[data-src]');
			each(images, (image) => {
				ScrollTrigger.create({
					trigger: section,
					start: 'top bottom-=100',
					onEnter: () => {
						this.loadImage(image);
					},
				});
			});
		});
	}

	loadImage(image) {
		const dataSrc = image.getAttribute('data-src');
		if (!dataSrc) return;

		image.src = dataSrc;
		// image.removeAttribute('data-src');
	}

	loadVideo(video) {
		const dataSrc = video.getAttribute('data-src');
		if (!dataSrc) return;

		video.src = dataSrc;
		// video.removeAttribute('data-src');
	}

	destroy() {
		ScrollTrigger.getAll().forEach((st) => st.kill());
	}
}
